import { call, put, all } from 'redux-saga/effects';

import { getRegistrationInfo, getRegistrationDeleteOrDeactivate } from '@api/registrations';
import { intl } from '@helpers/intl';
import { registrationsDetailGetModel } from '@models/Registrations';
import {
  registrationsInfoFetchSuccessAction,
  registrationsInfoFetchFailureAction,
} from '@store/registrations/registrationsDetail/registrationsInfo/registrationsInfo.actions';

export const registrationsInfoFetchSaga = function* ({ payload }) {
  try {
    const [infoResponse, deleteOrDeactivateResponse] = yield all([
      call(getRegistrationInfo, payload.regId, true),
      call(getRegistrationDeleteOrDeactivate, payload.regId),
    ]);

    yield put(
      registrationsInfoFetchSuccessAction({
        data: registrationsDetailGetModel({
          ...infoResponse,
          ...deleteOrDeactivateResponse?.canBeDeletedOrDeactivated,
        }),
      })
    );
  } catch (error) {
    const message =
      error.data?.nonFieldErrors ||
      intl.formatMessage({
        defaultMessage: 'An unexpected error occurred, please try again.',
        id: 'global.notification.api-error-default',
      });

    yield put(registrationsInfoFetchFailureAction({ errorMessage: message }));
  }
};
